module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "session-expire",
      "aria-hidden": "true",
      "data-keyboard": "false",
      "data-backdrop": "static",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "myModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("U wordt automatisch uitgelogd")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_vm._v("\r\n\t\t\t\tU bent bijna 30 minuten niet actief geweest binnen Mijn\r\n\t\t\t\tVerzekeringen. Voor de veiligheid van uw gegevens loggen wij u over\r\n\t\t\t\t"), _c('span', {
    attrs: {
      "id": "counter"
    }
  }, [_vm._v("60")]), _vm._v(" seconden automatisch uit.\r\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "id": "btnExtendSession",
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Ingelogd blijven")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "id": "btnLogoutAutologoutPrompt"
    }
  }, [_vm._v("Uitloggen")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1cdeacd4"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/frontend/components/session/endSession.vue
// module id = 20
// module chunks = 0